import { Component, OnInit } from '@angular/core';
import {UtilitiesService} from "../common/service/utilities.service";
import {CinchDataService} from "../common/service/cinch-data.service";
import {AuthService} from "../common/service/auth.service";
import {Router} from "@angular/router";
import {ApiContractDataModel} from "../common/model/cchsApiContractData.model";

interface User{
    sub?: string;
}

@Component({
  selector: 'app-myaccount',
  templateUrl: './myaccount.component.html',
  styleUrls: ['./myaccount.component.scss']
})
export class MyaccountComponent implements OnInit {
  // Inputs forms
  userSelected = ""
  contractSeleted = ""

  // Data sync variables
  test = true;
  user;
  users = [];
  userProfile = {};
  contract = {};


  constructor( private util:UtilitiesService,
               private cinchData: CinchDataService,
               private authService: AuthService) {

  }

  ngOnInit() {
    // Data sync
    this.cinchData.usersData$.subscribe(usersData => this.users = usersData , e => console.log());

    this.authService.userData$.subscribe(userData => {

      if ((userData) && (userData.idToken)) {
        this.user = userData.idToken.payload;
        if (userData.idToken.payload.sub ) {
            this.cinchData.fetchUserData(userData.idToken.payload.sub); //<----|| only if sub is available.
            this.cinchData.prodSub = this.cinchData._sub = userData.idToken.payload.sub;
        }
      }
    } , e => console.log());


    this.cinchData.userData$.subscribe(user => {
        this.userProfile = user;
     } , e => console.log());

    this.authService.fetchCurrentUserProfile();

    // Events handler from service
    this.cinchData.notification$.subscribe(x => console.log("notification$", x) , e => console.log());

  }
  getUser(uid){
    if (uid)  this.cinchData.fetchUserData(uid); //update user data.
    else this.user = {};
  }
  getContract( contractId, uid){
     if (contractId) {
       if ( !(this.cinchData.testMode) ) uid = this.cinchData._sub;
       if ( !(this.cinchData.testMode) || this.userSelected ) {
         this.cinchData.fetchContractData(contractId, uid);
         this.cinchData.fetchClaimsData(contractId,uid);
       }
     } //update contract data
  }
  toggleTestMode(){
    this.userProfile = {};
    this.cinchData.toggleTestMode();
  }

}
